module.exports = __webpack_public_path__ + "img/dcom11.075517af.png";